const SETTLE_MS = 4000;
const IDLE_TIMEOUT_MS = 5000;

export function afterSettle(run: () => void): () => void {
  let timer = 0;
  let idle = 0;
  let cancelled = false;
  const whenIdle = () => {
    if (cancelled) return;
    if (typeof window.requestIdleCallback === 'function') {
      idle = window.requestIdleCallback(run, { timeout: IDLE_TIMEOUT_MS });
    } else {
      run();
    }
  };
  const settled = () => {
    timer = window.setTimeout(whenIdle, SETTLE_MS);
  };
  if (document.readyState === 'complete') settled();
  else window.addEventListener('load', settled, { once: true });
  return () => {
    cancelled = true;
    window.removeEventListener('load', settled);
    window.clearTimeout(timer);
    if (idle && typeof window.cancelIdleCallback === 'function') window.cancelIdleCallback(idle);
  };
}
